import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';
interface ISlowResponse {
	is_slow: boolean;
}
const exportSlowGeneric = async <Params,>(module: string, params: Params) => {
	const response = await api.get<ISlowResponse>(
		`/${module}/export-csv/is-slow`,
		{
			params,
		}
	);
	return response.data?.is_slow;
};

export const useExportSlow = <Params,>(
	module: string,
	params: Params | undefined
) => {
	return useQuery(
		['export-is-slow', module, JSON.stringify(params)],
		() => exportSlowGeneric(module, params),
		{
			refetchOnWindowFocus: false,
			retry: 1,
			enabled: false,
		}
	);
};
